<div class="d-flex flex-column h-100">
    <app-header></app-header>
    <app-breadcrumbs></app-breadcrumbs>
    <app-toast></app-toast>

    <router-outlet></router-outlet>
    <app-footer class="mt-auto"></app-footer>
</div>